import { render, staticRenderFns } from "./ComponentDetail.vue?vue&type=template&id=c4de12da&scoped=true&"
import script from "./ComponentDetail.vue?vue&type=script&lang=ts&"
export * from "./ComponentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentDetail.vue?vue&type=style&index=0&id=c4de12da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4de12da",
  null
  
)

component.options.__file = "ComponentDetail.vue"
export default component.exports